// extracted by mini-css-extract-plugin
module.exports = {"container":"pagination_container__2tOTb"};